import { render } from "./OrderBackOutboxQueueListTableHeader.vue?vue&type=template&id=3789cf90"
import script from "./OrderBackOutboxQueueListTableHeader.vue?vue&type=script&lang=js"
export * from "./OrderBackOutboxQueueListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__